let profileModalSelector = '#profileModal';

$(document).ready(function () {
    initForm();
    initShowUserForm();

    $('.addProfile').on('click', function (event) {
        event.preventDefault();
        $(profileModalSelector).modal('show');
        $(profileModalSelector + ' input[name="userId"]').val('');
        $('#add-profile-form')[0].reset();
        showErrors([]);
    })
})

function initShowUserForm() {
    $('.editUser').on('click', function (event) {
        event.preventDefault();
        var formData = new FormData();
        var userId = $(this).attr('user-id');
        formData.append('userId', userId);
        $(profileModalSelector).modal('show');
        showErrors([]);
        $(profileModalSelector + ' input[name="userId"]').val(userId);

        $.ajax({
            type: 'post',
            url: '/company-registration-extended/show-user',
            data: formData,
            processData: false,
            contentType: false,
            success: function (res) {
                $(profileModalSelector + ' input[name="first_name"]').val(res.first_name);
                $(profileModalSelector + ' input[name="last_name"]').val(res.last_name);
                $(profileModalSelector + ' input[name="email"]').val(res.email);
                $(profileModalSelector + ' input[name="password"]').val(res.password);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.info('error onSubmitRaitingForm');
                console.info(jqXHR);
                console.info(textStatus);
                console.info(errorThrown);
            }
        });

    });
}

function initForm() {
    $('#add-profile-form').on('submit', function (event) {
        event.preventDefault();
        showErrors([]);
        var formData = new FormData(document.querySelector('#add-profile-form'));

        $.ajax({
            type: 'post',
            url: '/company-registration-extended/team-details',
            data: formData,
            processData: false,
            contentType: false,
            success: function (res) {
                if (res.success == false) {
                    showErrors(res.errors);
                    return true;
                }

                document.location.reload();
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.info('error onSubmitRaitingForm');
                console.info(jqXHR);
                console.info(textStatus);
                console.info(errorThrown);
            }
        });
    });
}

function showErrors(errors) {
    $('.text-error').remove();

    $.each(errors, function (key, val) {
        for (i in val) {
            $('input[name="' + key + '"]').parent().append('<span class="d-block text-error mx-auto">' + val[i] + '</span>');
        }
    })
}